export { default } from './WysiwygBlock'
